
import {
    CloseButton,
  Dialog,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from "@headlessui/react"
import { ChevronDownIcon, PhoneIcon, PlayCircleIcon, PlusCircleIcon, DocumentMagnifyingGlassIcon, QuestionMarkCircleIcon, FolderPlusIcon } from "@heroicons/react/20/solid"
import {
  ArrowPathIcon,
  Bars3Icon,
  ChartPieIcon,
  CursorArrowRaysIcon,
  FingerPrintIcon,
  SquaresPlusIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline"
import {
	json,
	type LoaderFunctionArgs,
	type HeadersFunction,
	type LinksFunction,
	type MetaFunction,
} from "@remix-run/node"
import {
	Form,
	Link,
	Links,
	Meta,
	Outlet,
	Scripts,
	ScrollRestoration,
	useLoaderData,
	useLocation,
	useMatches,
	useSubmit,
} from "@remix-run/react"
import { withSentry } from "@sentry/remix"
import { useEffect, useRef , useState } from "react"
import { HoneypotProvider } from "remix-utils/honeypot/react"
import { ServerSwitch } from "#app/routes/resources+/server-switch.js"
import { ThemeSwitch, useTheme } from "../routes/resources+/theme-switch.tsx"
import { getUserId, logout } from "../utils/auth.server.ts"
import { ClientHintCheck, getHints } from "../utils/client-hints.tsx"
import { prisma } from "../utils/db.server.ts"
import { getEnv } from "../utils/env.server.ts"
import { GeneralErrorBoundary } from "./error-boundary.tsx"
import { EpicProgress } from "./progress-bar.tsx"
import { SearchBar } from "./search-bar.tsx"
import { useToast } from "./toaster.tsx"
import { Button } from "./ui/button.tsx"
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuPortal,
	DropdownMenuTrigger,
} from "./ui/dropdown-menu.tsx"
import { Icon, href as iconsHref } from "./ui/icon.tsx"
import { EpicToaster } from "./ui/sonner.tsx"
import tailwindStyleSheetUrl from "./styles/tailwind.css?url"
import { honeypot } from "../utils/honeypot.server.ts"
import { combineHeaders, getDomainUrl, getUserImgSrc } from "../utils/misc.tsx"
import { useNonce } from "../utils/nonce-provider.ts"
import { type Theme, getTheme } from "../utils/theme.server.ts"
import { makeTimings, time } from "../utils/timing.server.ts"
import { getToast } from "../utils/toast.server.ts"
import { type useOptionalUser, useUser } from "../utils/user.ts"
import * as gtag from "../utils/gtags.client.ts";
import Logo from "./logo.tsx";

import { brandUrl } from "./branding.tsx"

const callsToAction2 = [
    { name: "Watch demo", href: "#", icon: PlayCircleIcon },
    { name: "Ask a question", href: "#", icon: PhoneIcon },
  ]
  

const basicLinks = [
    { name: "Scripts", href: "/scripts", icon: null, popover:  [
      { name: "Scripts by Server", description: "Training, Utility, Organization", href: "/scripts/servers", icon: ChartPieIcon },
      { name: "Scripts by Type", description: "Training, Utility, Organization", href: "/scripts/categories", icon: ChartPieIcon },
      { name: "Scripts by Skill", description: "View a list of skills", href: "/scripts/skills", icon: DocumentMagnifyingGlassIcon },
      //{ name: "Official Jase Owns", description: "Jaseowns personal crafted scripts", href: "/users/jaseowns", icon: FolderPlusIcon },
    //   { name: "Offical Jaseowns", description: "Connect with third-party tools", href: "#", icon: SquaresPlusIcon },
      { name: "Recent Edits", description: "Updates by members of the community", href: "/scripts/recent", icon: ArrowPathIcon },
    ], popoverCta: [
      { name: "Submit script", href: "/script/new", icon: PlusCircleIcon },
      { name: "View all scripts", href: "/scripts", icon: DocumentMagnifyingGlassIcon },
      //{ name: "Request a script", href: "/script/request", icon: QuestionMarkCircleIcon },
    ]
      },
    // { name: "Database", href: "/database", icon: null, popover: [
    //   { name: "Items", href: "/items", icon: ChartPieIcon, description: "View a list of items" },
    //   { name: "Monsters", href: "/monsters", icon: ChartPieIcon, description: "View a list of monsters" },
    //   { name: "Users", href: "/users", icon: ChartPieIcon, description: "View a list of users" },
    //   { name: "Questions", href: "/questions", icon: ChartPieIcon, description: "View a list of questions" },
    // ], popoverCta: [
    //   { name: "Answer a question", href: "/questions/open", icon: PlusCircleIcon },
    //   { name: "Ask a question", href: "/questions/new", icon: QuestionMarkCircleIcon },
    // ] },
    
    { name: "Guides", href: "/guides", icon: null, popover: [
      { name: "What is UO and how do I get started?", description: "There are many options when it comes to playing UO - learn about why this old wizard game from 1997 is still one of the greatest ever made and how you can play for free!", href: "/guides/free-to-play-uo", icon: ChartPieIcon },
      { name: "Hues", description: "Select the perfect color for your in game message or overhead", href: "/hues", icon: PlusCircleIcon },
    ], popoverCta: [
      // { name: "Create a guide", href: "/guides/new", icon: PlusCircleIcon },
      // { name: "View all guides", href: "/guides", icon: DocumentMagnifyingGlassIcon },
    ] },
    { name: "Build Templates", href: "/builds", icon: null, popover: [
      { name: "PVM", description: "Player vs Monster builds", href: "/builds/tags/pvm", icon: ChartPieIcon },
      { name: "PVP", description: "Player vs Player builds", href: "/builds/tags/pvp", icon: DocumentMagnifyingGlassIcon },
      // { name: "Mage", description: "Magery builds", href: "/builds/tags/mage", icon: DocumentMagnifyingGlassIcon },
      // { name: "Warrior", description: "Warrior builds", href: "/builds/tags/warrior", icon: DocumentMagnifyingGlassIcon },
      // { name: "Bard", description: "Bard builds", href: "/builds/tags/bard", icon: DocumentMagnifyingGlassIcon },
      // { name: "Gathering", description: "Gathering builds", href: "/builds/tags/gather", icon: DocumentMagnifyingGlassIcon },
      // { name: "Crafting", description: "Crafting builds", href: "/builds/tags/crafting", icon: DocumentMagnifyingGlassIcon },
      { name: "Recent Builds", description: "Updates by members of the community", href: "/builds/recent", icon: ArrowPathIcon },

    ], popoverCta: [
      { name: "Submit build", href: "/builds/new", icon: PlusCircleIcon },
      { name: "View all builds", href: "/builds", icon: DocumentMagnifyingGlassIcon },
    ] },
    {name: "Watch UO Streamers", href:"/streamers", icon: null, popover: null},
    { name: "UO Servers", href: "/servers", icon: null, popover: null },
    { name: "Support", href: "/support", icon: null, popover: null },
    //{ name: "Company", href: "/company", icon: null },
]

export default function Header(
    {user, searchBar, selectedServer}: {
        user: ReturnType<typeof useOptionalUser>
        searchBar: React.ReactNode,
        selectedServer: string | null
    }
) {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
	const formRef = useRef<HTMLFormElement>(null)

    return (
    <div>
<header className="bg-muted">
      <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
        <div className="flex lg:flex-1">
          <span className="-m-1.5 p-1.5">
            <span className="sr-only">Early Access UOAddicts.com</span>
            <Logo />
          </span>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="h-6 w-6" />
          </button>
        </div>
        <PopoverGroup className="hidden lg:flex lg:gap-x-12">
            {
                basicLinks.map((item) => {

                    if (item.popover) {
                        return (
        <Popover className="relative" key={`${item.name}_popover`}>
            <PopoverButton className="flex items-center gap-x-1 text-sm font-semibold leading-6">
              {item.name}
              <ChevronDownIcon aria-hidden="true" className="h-5 w-5 flex-none text-gray-400" />
            </PopoverButton>
            <PopoverPanel
              transition
              className="absolute -left-8 top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
            >

              <div className="p-4">
                {item.popover.map((item) => (
                  <div
                    key={item.name}
                    className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm leading-6 hover:bg-gray-50"
                  >
                    <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                      <item.icon aria-hidden="true" className="h-6 w-6 text-gray-600 group-hover:text-blue-600" />
                    </div>
                    <div className="flex-auto">
                        
                        <Link to={item.href} className="block font-semibold text-gray-900">
                            <CloseButton>
                            {item.name}
                            <span className="absolute inset-0" />
                            </CloseButton>
                        </Link>
                       
                      <p className="mt-1 text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              {item.popoverCta && item.popoverCta.length ? 
              <div className="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                {item.popoverCta.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100"
                  >
                    <CloseButton>
                        <item.icon aria-hidden="true" className="h-5 w-5 flex-none text-gray-400 inline-block mr-4" />
                        {item.name}
                    </CloseButton>
                  </Link>
                ))}
              </div> : <></>
                              }
            </PopoverPanel>
          </Popover>

                        )
                    }

                    return (
                    <Link
                        key={item.name}
                        to={item.href}
                        className="text-sm font-semibold leading-6"
                    >
                        {item.name}
                    </Link>
                    )}
                )
            }
        </PopoverGroup>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            {user ? (
                <Form action="/logout" method="POST" ref={formRef}>
                    <Icon className="text-sm font-semibold leading-6" name="exit">
                        <button className="text-sm font-semibold leading-6" type="submit">Logout</button>
                    </Icon>
                </Form>
            ) : (
                <Link className="text-sm font-semibold leading-6" to="/login">Log In <span aria-hidden="true">&rarr;</span></Link>
            )}

        </div>
      </nav>
      
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <span className="-m-1.5 p-1.5">
              <span className="sr-only">{brandUrl}</span>
              <Logo />
            </span>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {
                    basicLinks.map((item) => { 
                        
                        if (item.popover) {

                          
                        return  <Disclosure as="div" className="-mx-3" key={`${item.name}_disclosure`}>
                                <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50">
                                {item.name}
                                <ChevronDownIcon aria-hidden="true" className="h-5 w-5 flex-none group-data-[open]:rotate-180" />
                                </DisclosureButton>
                                <DisclosurePanel className="mt-2 space-y-2">
                                {item.popoverCta ? [...item.popover, ...item.popoverCta].map((nextCta) => (
                                    <DisclosureButton
                                    key={nextCta.name}
                                    as="a"
                                    href={nextCta.href}
                                    onClick={() => setMobileMenuOpen(false)}
                                    className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                                    >
                                    {nextCta.name}
                                    </DisclosureButton>
                                )) : <></>}
                                </DisclosurePanel>
                            </Disclosure>
                        }
                        
                        return (

                        <Link
                            key={item.name}
                            to={item.href}
                            onClick={() => setMobileMenuOpen(false)}
                            className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                        >
                            {item.name}
                        </Link>
                        )}
                    )
                }
              </div>
              <div className="py-6">
                {user ? (
                    <Form action="/logout" method="POST" ref={formRef}>
                        <Icon className="text-sm font-semibold leading-6 text-gray-900" name="exit">
                            <button className="text-sm font-semibold leading-6 text-gray-900" type="submit">Logout</button>
                        </Icon>
                    </Form>
                ) : (
                    <Link onClick={() => setMobileMenuOpen(false)} className="text-sm font-semibold leading-6 text-gray-900" to="/login">Log In</Link>
                )}
                 </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
        <div className="container py-6">
            <nav className="flex flex-wrap items-center justify-between gap-4 sm:flex-nowrap md:gap-8">
                <Link to="/developer-roadmap" className="group grid leading-snug">
                    <span className="font-light transition group-hover:-translate-x-1">
                      🔨 Development Roadmap
                    </span>
                </Link>
                <div className="ml-auto hidden max-w-sm flex-1 sm:block">
                    {searchBar}
                </div>
                <div className="flex items-center gap-5">
                    <ServerSwitch userPreference={selectedServer} />
                    {user ? (
                        <UserDropdown />
                    ) : (
                        <Button asChild variant="default" size="lg">
                            <Link to="/login">Log In</Link>
                        </Button>
                    )}
                    </div>
                <div className="block w-full sm:hidden">{searchBar}</div>
            </nav>
        </div>
    </div>
    )
}



function UserDropdown() {
	const user = useUser()
	const submit = useSubmit()
	const formRef = useRef<HTMLFormElement>(null)
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button asChild variant="secondary">
					<Link
						to={`/users/${user.username}`}
						// this is for progressive enhancement
						onClick={(e) => e.preventDefault()}
						className="flex items-center gap-2"
					>
						<img
							className="h-8 w-8 rounded-full object-cover"
							alt={user.name ?? user.username}
							src={getUserImgSrc(user.image?.id)}
						/>
						<span className="text-body-sm font-bold">
							{user.username}
						</span>
					</Link>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuPortal>
				<DropdownMenuContent sideOffset={8} align="start">
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to={`/users/${user.username}`}>
							<Icon className="text-body-md" name="avatar">
								Profile
							</Icon>
						</Link>
					</DropdownMenuItem>
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to={`/users/${user.username}/characters`}>
							<Icon className="text-body-md" name="moon">
								Characters
							</Icon>
						</Link>
					</DropdownMenuItem>
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to={`/users/${user.username}/notes`}>
							<Icon className="text-body-md" name="pencil-2">
								Notes
							</Icon>
						</Link>
					</DropdownMenuItem>
					<DropdownMenuItem
						asChild
						// this prevents the menu from closing before the form submission is completed
						onSelect={(event) => {
							event.preventDefault()
							submit(formRef.current)
						}}
					>
						<Form action="/logout" method="POST" ref={formRef}>
							<Icon className="text-body-md" name="exit">
								<button type="submit">Logout</button>
							</Icon>
						</Form>
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenuPortal>
		</DropdownMenu>
	)
}
